import * as React from "react";
import BaseUI, { IBaseUI } from "src/engine/ui/BaseUI";
import { IPanelContext } from "src/engine/context/PanelContext";
import "./UIList.scss";
import { StyleSheet } from "src/lib/utils/Style";
// import ButtonLink from "./ButtonLink";
import IUIItem from "src/engine/interface/IUIItem";
import UIManifest from "src/engine/ui/UIManifest";

interface IUIList extends IBaseUI {
    // goto:string;
    goButton: IUIItem[];
    showCount: string;
    className: string;
    zeroClass?: string;
    showTag: string;
    handleRet: any;
    noData?: any;
    value?: any;
    useSource?: boolean;
}

@UIManifest.declare("UIList", undefined, UIManifest.Type.Discard)
class UIList extends BaseUI<IUIList> {
    styleSheet = [StyleSheet.h, StyleSheet.bgImg, StyleSheet.margin, StyleSheet.minHeight];

    state = {
        visible: false
    };

    renderItems(data: any[]) {
        const { children, showCount, showTag, handleRet, noData } = this.props;
        const showTagFlag = showTag === "true" ? true : false;
        if (!children || children.length === 0 || data.length === 0) {
            if (noData) {
                return this.renderChildren(noData);
            }
            return null;
        }
        if (JSON.stringify(data) === "{}" || !data.map) return null;
        return this.panel((context: IPanelContext) => {
            const length = data.length;
            return data.map((item, key) => {
                if (key >= Number(showCount || data.length)) return null;
                const list = { index: key, length, totalIndex: length - 1 };
                return item
                    ? this.renderUIItem(children[0], context, {
                          data: item,
                          list,
                          key,
                          handleRet,
                          showTag: showTagFlag,
                          isZoom: showTagFlag && key === 0 ? true : false
                      })
                    : null;
                // return (
                //     <div key={key}>
                //         {this.renderUIItem(children[0], context, {
                //             data: item,
                //             key,
                //             handleRet,
                //             showTag: showTagFlag,
                //             isZoom: showTagFlag && key === 0 ? true : false
                //         })}
                //     </div>
                // );
                // return this.renderUIItem(children[0], context, { data: item, key });
            });
        });
    }

    render() {
        const { dataSource, source, uiItem, useSource, goButton = [], showTag, className, showCount, value, zeroClass } = this.props;
        const showTagClass = showTag ? "showTag" : "";
        // const data = dataSource && dataSource.data ? dataSource.data : dataSource;
        let data: any = [];
        if (dataSource) {
            data = dataSource.data ? dataSource.data : dataSource;
        } else if (value) {
            data = value;
        }
        let tempKey = uiItem.info.ename;
        if (useSource === true && source) {
            if (source.indexOf(".") > 0) {
                tempKey = source.split(".")[1];
            } else {
                tempKey = source;
            }
        }
        return (
            <div className={`react-ui-list ${className} ${showTagClass} ${data.length === 0 ? zeroClass : ""}`} style={this.getStyle()}>
                {this.renderItems(data || [])}
                {/* <div className="more">查看更多+</div> */}
                {goButton.length > 0
                    ? this.renderChildren([goButton[0]], {
                          dataSource: "dataList.pagination",
                          pageSize: Number(showCount),
                          tempKey
                      })
                    : null}
                {/* <ButtonLink
                    goto={`${}&${dataSource}`}
                    title={"查看更多+"}
                    uiItem={{ info: { ename: "c", cname: "c" }, ui: "ButtonLink" }}
                    className="more"
                /> */}
            </div>
        );
    }
}

export default UIList;
